import React from 'react'
import './Style/header.css'
import Logo from '../Image/logo.png'
function Header() {
  return <header>     
  <div className="brand">
      <img src={Logo} className='logo' alt="" />
      <h3>Brande Name</h3>
      <p> tagline space here</p>
  </div>
  <div className="info">
      <h1>invoice</h1>
      <div className="invoice-num">
          <h4>invoice#</h4>
          <span> 5241B</span>
          
      </div>
      <div className="date">
          <h4>date</h4>
          <span>01  /02  /2022</span>
      </div>
  </div>
</header>
}

export default Header